var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9963 18.9688C9.605 18.9688 5 19.8187 5 23.2187C5 26.62 9.57625 27.5 14.9963 27.5C20.3875 27.5 24.9925 26.6512 24.9925 23.25C24.9925 19.8487 20.4175 18.9688 14.9963 18.9688Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.9959 15.73C18.6684 15.73 21.6109 12.7863 21.6109 9.115C21.6109 5.44375 18.6684 2.5 14.9959 2.5C11.3246 2.5 8.38086 5.44375 8.38086 9.115C8.38086 12.7863 11.3246 15.73 14.9959 15.73Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile-3.62d70047a166d69ab19a176f82aada51.svg";
export { ForwardRef as ReactComponent };